export default {
    'sv-SE': {
        //Errors
        device_id_validation_error:
            'Id måste vara 16 tecken samt bestå av siffror och versaler A-F.',
        cancel: 'avbryt',
        error_has_occured: 'ett fel har uppstått',
        error_report_failed: 'felrapport kunde inte skickas',
        enter_your_username: 'ange ditt användarnamn ovan',
        error_report_sent: 'felrapport skickad',
        error_when_deleting_device: 'enhet kunde inte tas bort',
        error: 'fel',
        failed: 'misslyckades',
        go_to_start: 'gå till början',
        please_contact_us: 'vänligen kontakta oss',
        save: 'spara',
        sending_error_report: 'skickar felrapport',
        sending: 'skickar',
        sent: 'skickat',
        send: 'skicka',
        invalid_position_value:
            'position måste vara i formatet: Longitud, Latitud. Ex: 16.3, 56.8',
        username: 'användarnamn',
        password: 'lösenord',
        confirm_password: 'bekräfta lösenord',
        login: 'logga in',
        error_invalid_token: 'ogiltig token',
        error_invalid_credentials: 'ogiltigt användarnamn eller lösenord',
        error_general: 'något gick fel',
        error_check_spelling: 'kontrollera din stavning',
        error_general_unauthorized: 'otillåten begäran',
        error_internal: 'internt fel eller nätverksfel',
        error_unable_to_update_password:
            'Kunde inte ändra lösenord. Var god begär en ny återställningslänk',
        reset_password_match_error: 'Kontrollera att lösenorden matchar.',
        reset_password: 'återställ lösenord',
        forgot_password: 'glömt lösenord',
        password_reset_requested:
            'vi har skickat instruktioner till din e-postadress',
        password_reset_completed: 'ditt lösenord har uppdaterats',
        return_to_login: 'tillbaka till login',
        logging_in: 'loggar in...',
        logging_out: 'loggar ut...',
        unsupported_browser_title:
            'Er webläsare saknar stöd för vissa av de funktioner som används av våra verktyg',
        unsupported_browser_msg:
            'Det är därför möjligt att verktygen inte fungerar som de ska. För en optimal upplevelse rekommenderar vi att ni uppgraderar er webläsare. Chrome är att föredra.',
    },
    'en-US': {
        //Error
        device_id_validation_error:
            'Id must be 16 characters and consist of numbers and capital letters A-F only.',
        error_has_occured: 'an error has occured',
        error_report_failed: 'could not send error report',
        error_report_sent: 'sending error report',
        error_when_deleting_device: 'error when deleting device',
        error: 'Error',
        failed: 'failed',
        go_to_start: 'gå till början',
        please_contact_us: 'please contact us',
        save: 'save',
        sending_error_report: 'sending error report',
        sending: 'sending',
        sent: 'sent',
        send: 'send',
        username: 'username',
        password: 'password',
        login: 'login',
        error_invalid_token: 'invalid token',
        error_invalid_credentials: 'invalid username or password',
        error_general_unauthorized: 'unauthorized',
        error_general: 'error',
        error_check_spelling: 'check your spelling',
        error_internal: 'internal error',
        error_unable_to_update_password:
            'Unable to update password. Please request a new reset and try again',
        reset_password_match_error: 'Check that the passwords provided match.',
        reset_password: 'reset password',
        password_reset_requested:
            'instructions have been sent to your email address',
        password_reset_completed: 'your password has been updated',
        return_to_login: 'return to login',
        logging_in: 'loggin in...',
        logging_out: 'logging out...',
        unsupported_browser_title:
            'Your browser appears to lack support for some of the features our tools use',
        unsupported_browser_msg:
            'The tools may therefore not work properly, and we recommend that you upgrade your browser',
    },
};



// WEBPACK FOOTER //
// ./src/translations.ts